import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { refreshAuthLogic } from 'services/main';
import { addBearerTokenInReq } from 'services/main/interceptors/addBearerTokenInReq';
import { checkIfSessionExpired } from 'services/main/interceptors/checkIfSessionExpired';
import { addSentryLoggingInterceptor } from 'services/main/interceptors/addSentryLogginInterceptor';

// --- Axios instances ---
const AxiosReports = axios.create({
  baseURL: process.env.REACT_APP_REPORTS_API,
});

const AxiosReportLas = axios.create({
  baseURL: process.env.REACT_APP_LAS,
});

const AxiosGlobalFilters = axios.create({
  baseURL: process.env.REACT_APP_LIGHTHOUSE_FILTERS_API,
});

// --- Request interceptors (pré-emptivo) ---
AxiosGlobalFilters.interceptors.request.use(addBearerTokenInReq);
AxiosGlobalFilters.interceptors.request.use(checkIfSessionExpired);

AxiosReports.interceptors.request.use(addBearerTokenInReq);
AxiosReports.interceptors.request.use(checkIfSessionExpired);

AxiosReportLas.interceptors.request.use(addBearerTokenInReq);
AxiosReportLas.interceptors.request.use(checkIfSessionExpired);

// --- Auth refresh interceptor (reativo) ---
createAuthRefreshInterceptor(AxiosGlobalFilters, refreshAuthLogic);
createAuthRefreshInterceptor(AxiosReports, refreshAuthLogic);
createAuthRefreshInterceptor(AxiosReportLas, refreshAuthLogic);

// --- Sentry logging interceptor (último, captura estado final) ---
addSentryLoggingInterceptor(AxiosReports);
addSentryLoggingInterceptor(AxiosReportLas);
addSentryLoggingInterceptor(AxiosGlobalFilters);

// --- Export ---
export { AxiosReports, AxiosGlobalFilters, AxiosReportLas };
